import type { ExtraDetails, HeatingKey, SingleBuildingFormState } from "../model/types";

import { EpcExtractionData } from "../components/address-step/epc-modal/types";
import { getEpcAutofillValues } from "./epcSuggestedFields";

const keyValueOrEmpty = <T>(key: string, value: null | T | undefined): Record<string, T> => {
  if (value != null) return { [key]: value };
  return {};
};

export const applyEpcExtractionToFormData = (
  prev: SingleBuildingFormState,
  epcData: EpcExtractionData,
  options?: { preserveAddress?: boolean }
): SingleBuildingFormState => {
  const autofill = getEpcAutofillValues(epcData);

  return {
    ...prev,
    ...(options?.preserveAddress
      ? {}
      : {
          addressInfo: {
            ...prev.addressInfo,
            ...autofill.addressInfo,
          },
        }),
    details: {
      ...prev.details,
      ...keyValueOrEmpty("building_type", autofill.buildingType.building_type),
      ...keyValueOrEmpty("mixConfiguration", autofill.buildingType.mixConfiguration),
      ...keyValueOrEmpty("construction_year", autofill.constructionYear),
      ...keyValueOrEmpty("rental_units", autofill.rentalUnits),
    },
    epcExtractionData: epcData,
    extraDetails: {
      ...(prev.extraDetails as ExtraDetails),
      heating_system: (autofill.heating_system as HeatingKey) ?? prev.extraDetails?.heating_system,
      installation_date: autofill.installation_date ?? prev.extraDetails?.installation_date,
      mechanical_ventilation: autofill.mechanical_ventilation ?? prev.extraDetails?.mechanical_ventilation,
    },
  };
};
